import { Component, Input } from "@angular/core";

@Component({
  selector: "app-rating",
  templateUrl: "./rating.component.html",
  styleUrls: ["./rating.component.css"],
  standalone: false,
})
export class RatingComponent {
  @Input() currentRate: number;
  color = "red";
}
